import '../../common/utilities/Section.scss';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { Stack, Box } from '@mui/material';
import { Job, JobType } from '../../common/apis/dtos';
import { StopsSummary } from './StopsSummary';
import { RouteStatus } from '../../common/utilities/display-utilities';

export interface ShipmentRouteProps {
  shipment: Job;
  isMobileScreen: boolean;
}

export const ShipmentRoute = ({
  shipment,
  isMobileScreen,
}: ShipmentRouteProps) => {
  const translate = useTranslation();
  const jobTypeText = shipment.jobType == JobType.Shipment ? translate('Shipment Route') : translate('Order Progress');

  return (
    <Stack data-testid="shipment-route" className="section">
      <Stack
        direction="row"
        className="section-heading"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Box>{jobTypeText}</Box>
        <Box>{RouteStatus(shipment, translate)}</Box>
      </Stack>
      <StopsSummary stops={shipment.stops} shipmentModeCode={shipment.modeCode} cargoReady={shipment.cargoReady} isMobileScreen={isMobileScreen} />
    </Stack>
  );
};
